<template>
  <modal-template :name="modalName">
    <template slot="header">
      <h2 class="h2" v-t="'modal.cart_timer_warning'"></h2>
    </template>
    <template slot="default">
      <p v-t="'modal.cart_timer_body'"></p>
    </template>
    <template slot="footer">
      <button class="btn--inverted"
        @click="close"
        v-t="'buttons.ok_got_it'"/>
    </template>
  </modal-template>
</template>
<script>
import ModalTemplate from "@/components/modals/ModalTemplate.vue";

export default {
  name: "modal-cart-time-warning",
  components: {
    ModalTemplate
  },
  data() {
    return {
      modalName: "modal-cart-time-warning"
    };
  },
  methods: {
    close() {
      this.$modal.hide(this.modalName);
    },
  }
};
</script>